import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { TDateRange } from '@/shared/types/app.types';
import { BookingType, IBookingObjects, IObject } from '@/shared/types/bookingObjects.types';

interface BookingStore {
	bookingType: BookingType;
	bookingDate: TDateRange | null;
	bookingPlace: IBookingObjects | null;
	bookingLocation: IObject | null;
	bookingLocationPath: string[];
	setBookingType: (type: BookingStore['bookingType']) => void;
	setBookingDate: (dates: BookingStore['bookingDate']) => void;
	setBookingPlace: (place: BookingStore['bookingPlace']) => void;
	setBookingLocation: (location: BookingStore['bookingLocation']) => void;
	setBookingLocationPath: (location: BookingStore['bookingLocationPath']) => void;
}

const useBookingStore = create<BookingStore>()(
	devtools((set) => ({
		bookingType: 'work_place',
		bookingDate: [null, null],
		bookingPlace: null,
		bookingLocation: null,
		bookingLocationPath: [],
		setBookingType: (bookingType) => set(() => ({ bookingType })),
		setBookingDate: (bookingDate) => set(() => ({ bookingDate })),
		setBookingPlace: (bookingPlace) => set(() => ({ bookingPlace })),
		setBookingLocation: (bookingLocation) => set(() => ({ bookingLocation })),
		setBookingLocationPath: (bookingLocationPath) => set(() => ({ bookingLocationPath })),
	})),
);

export default useBookingStore;
